import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/index'
import News from '@/components/news'
import Projects from '@/components/projects'
import Project from '@/components/project'
import E404 from '@/components/404'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Index
  },
  {
    path: '/news/:pagenr',
    name: 'News',
    component: News
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/project/:id',
    name: 'Project',
    component: Project
  },
  {
    path: '*',
    name: '404',
    component: E404
  }
]

export default new Router({
  mode: 'history',
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js